import { version as livekitVersion } from 'livekit-client'
import dgPackage from '@deepgram/sdk/package.json'
import azurePackage from 'microsoft-cognitiveservices-speech-sdk/package.json'

export const versions = {
  'livekit-client': livekitVersion,
  '@deepgram/sdk': dgPackage.version,
  'microsoft-cognitiveservices-speech-sdk': azurePackage.version
}
